export default {
  SET_SUBSCRIBE_ERROR: "SET_SUBSCRIBE_ERROR",

  ADD_CANCEL: "setSubscribeCancel",
  ADD_REASON: "setSubscribeReservationReason",

  AMOUNT_INVITE_CODE: "setSubscribePointCode",

  SET_SUBSCRIBE_ORDER_ID: "setSubscribeOrderId",
  SET_SUBSCRIBE_OFFER: "setSubscribeOffer",
  SET_SUBSCRIBE_INFO: "setSubscribeInfo",
  SET_SUBSCRIBE_ADDRESS_CHANGE: "setSubscribeAddressChange",
  SET_SUBSCRIBE_ANALYZE_DEFAULT: "setSubscribeAnalyzeDefault",
};

export const initialSubscribeOrderState = {
  /** @type {number | null} 구독번호 */
  id: null,
  /** @type {number | null} 주문번호 */
  merchantUid: null,
  /** @type {string | null} 주문상태 */
  status: null,
};

export const initialSubscribeBulkState = {
  /** @type {number | null} 구독번호 */
  id: null,
  /** @type {number | null} 주문번호 */
  merchantUid: null,
};

export const initialSubscribeInfoState = {
  /** @type {number | null} 구독번호 */
  subscribeSeq: null,
  /** @type {string | null} 주소 */
  fullAddress: null,
  /** @type {string | null} 카드명 */
  cardName: null,
  /** @type {string | null} 카드번호 */
  cardNumber: null,
  /** @type {string | null} 재결제일 */
  orderDate: null,
  /** @type {string | null} 결제금액 */
  orderPrice: null,
  /** @type {boolean | null} 구독중지여부부 */
  hasSubscribe: null,
  /** @type {boolean | null} 해지예약여부 */
  hasReservation: null,
  /** @type {string | null} 시작일 */
  createDate: null,
  /** @type {string | null} 해지예정일 */
  cancelDueDate: null,
  /** @type {boolean | null} 선택구분자 */
  selected: null,
};

export const initialSubscribeAddressChangeState = {
  /** @type {boolean | null} 주소변경 가능여부 */
  isExpired: null,
};
